import {createApi} from '@reduxjs/toolkit/dist/query/react'
import {baseQueryWithReauth} from './BaseQueryReauth'

interface IResponse {
  status: string
  detail: string
}

export const crmAPI = createApi({
  reducerPath: 'crmAPI',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['crm'],
  endpoints: (build) => ({
    checkBitrix24Tokens: build.query<IResponse, string>({
      query: (crm_domain) => ({
        url: `/crm/bitrix24/${crm_domain}`,
      }),
    }),
    checkAmoCRMTokens: build.query<IResponse, string>({
      query: (crm_domain) => ({
        url: `/crm/amocrm/${crm_domain}`,
      }),
    }),
    downloadModule1C: build.query<{blob: Blob; filename: string}, void>({
      query: () => ({
        url: `/crm/1c/modules`,
        responseHandler: async (response) => {
          const blob = await response.blob()
          const disposition = response.headers.get('Content-Disposition')
          const match = disposition?.match(/filename="?(.+?)"?$/)
          const filename = match?.[1] || 'module-1c.zip'
          return {blob, filename}
        },
        cache: 'no-cache',
      }),
    }),
    getToken1C: build.query<string, string>({
      query: (app_id) => ({
        url: `/crm/1c/token/${app_id}`,
      }),
    }),
  }),
})
